import {ColumnProps} from "antd/es/table";
import {convertIosStringToDate, formatDateToString} from "helper/common";
import moment from "moment";
import React from "react";
import {FORMAT_TIME} from "types/enums";
const columns: ColumnProps<any>[] = [
  {key: "1", title: "ID", dataIndex: "id"},
  {key: "2", title: "Tên", dataIndex: "username", align: "left"},
  {key: "3", title: "Công ty", dataIndex: "company", align: "left"},
  {key: "4", title: "Vị trí", dataIndex: "jobTitle", align: "left"},
  {key: "5", title: "Địa điểm", dataIndex: "location", align: "left"},
  {
    key: "6",
    title: "Ngày bắt đầu",
    dataIndex: "startDate",
    render(value, record, index) {
      return (
        <div>{value ? moment(value).format(FORMAT_TIME.dayFull) : null}</div>
      );
    },
  },
  {
    key: "7",
    title: "Ngày kết thúc",
    dataIndex: "endDate",
    render(value, record, index) {
      return (
        <div>{value ? moment(value).format(FORMAT_TIME.dayFull) : null}</div>
      );
    },
  },
  {key: "8", title: "Mô tả", dataIndex: "description", align: "left"},
  {key: "9", title: "Thao tác", dataIndex: "action"},
];
export {columns};
